import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import ContractRefundStatusCode from 'models/enums/ContractRefundStatusCode';

type ContractRefundStatusProps = {
  statusCode: Model.Enum.ContractRefundStatusCode;
};
export default function ContractRefundStatus({ statusCode }: ContractRefundStatusProps) {
  const { translate } = getLocales();
  return (
    <span
      style={
        statusCode === ContractRefundStatusCode.CANCELLED
          ? { color: Theme.Color.error, fontWeight: 'bold' }
          : statusCode === ContractRefundStatusCode.PAID || statusCode === ContractRefundStatusCode.PAID_NOREFUND
            ? { color: Theme.Color.success, fontWeight: 'bold' }
            : undefined
      }
    >
      {translate(statusCode)?.replace(/_/g, ' ')}
    </span>
  );
}
